import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { useMemo } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {

    const profileFilter = chooseProfileFilter(); 
    const pathFrontEnd = '/governanceroom/clientscities/';
    const paths = { 
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: `${config.endpoints.backend}governanceroom/clientscities/getall`,
        endpointDelete: `${config.endpoints.backend}governanceroom/clientscities/delete`,
    }

    const list = useMemo(() => ({
        labelTitle: 'Municípios',
        labelTitleButtonAdd: 'Novo Município',
        fieldsShowOnDelete: ['company_name'],
        showPrintButtons: false,
        filter:{
          ...profileFilter
        },
        canDelete: true,
        canEdit: true,
        columns: [
            {
                name: 'client_name',
                label: 'Cliente',
                width: '25%'
            },
            {
                name: 'cnpj',
                label: 'cnpj',
                width: '20%'
            },
            {
                name: 'company_name',
                label: 'Razão Social',
                width: '30%'
            },
            {
                name: 'status_name',
                label: 'Status',
                width: '12%'
            },
        ],
        ...paths
    }), []);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, list.labelTitle, list.labelTitleButtonAdd, paths.pathAdd]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;